import {
  faReact,
  faHtml5,
  faJs,
  faJava,
  faNodeJs,
  faGit,
  faGithub,
  faCss3,
} from "@fortawesome/free-brands-svg-icons";

import { faDatabase } from "@fortawesome/free-solid-svg-icons";

export const projectsData = [
  {
    name: "DKAB Resfebe",
    description:
      "An educational brain teaser game that challenges users to find hidden words using a combination of pictures, letters, and symbols.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio/resfebe.webp",
    url: "https://play.google.com/store/apps/details?id=com.abdllhalioglu.resfebe",
    source: "https://github.com/AbdllhAlioglu",
    imageAlt:
      "Resfebe mobile game interface featuring visual word puzzles and cognitive logic challenges",
  },
  {
    name: "Electro Shop Admin Panel",
    description: "A simple admin panel for the Electro Shop app.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//admin-panel-min.webp",
    url: "https://electro-shop-admin.vercel.app/",
    source: "https://github.com/AbdllhAlioglu/electro-shop-admin",
    imageAlt:
      "Electro Shop Admin Panel interface for e-commerce management with product listings, user data and sales analytics",
  },
  {
    name: "Electro Shop",
    description: "A simple e-commerce app built with React and Redux.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//shop-min.webp",
    url: "https://electro-shop-market.vercel.app/",
    source: "https://github.com/AbdllhAlioglu/electro-shop",
    imageAlt:
      "Electro Shop e-commerce platform showcasing electronics products with shopping cart functionality built with React and Redux",
  },
  {
    name: "Fikirtepe",
    description: "A web app showcasing construction projects with summaries.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//Fikirtepe-min%20(1).webp",
    url: "https://abdllhalioglu.github.io/Fikirtepe/",
    source: "https://github.com/AbdllhAlioglu/Fikirtepe",
    imageAlt:
      "Fikirtepe construction projects showcase website with property listings and project summaries created with modern web technologies",
  },
  {
    name: "Cinemagic",
    description:
      "A movie database app using the OMDb API for fetching details.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//cine-magic-min.webp",
    url: "https://cine-magic-fawn.vercel.app/",
    source: "https://github.com/AbdllhAlioglu/CineMagic",
    imageAlt:
      "Cinemagic movie database web application showing film listings and search functionality built with React and OMDb API",
  },
  {
    name: "Journey Prep",
    description: "A web app for preparing for your journey.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//journey-prep-min.webp",
    url: "https://travel-list-six-theta.vercel.app/",
    source: "https://github.com/AbdllhAlioglu/travel-list",
    imageAlt:
      "Journey Prep travel planning application with packing list and trip organization features created with React hooks",
  },
  {
    name: "Javascript Quiz",
    description:
      "A quiz application that tests your knowledge of JavaScript concepts and syntax.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//quiz-min.webp",
    url: "https://javascript-quiz-psi.vercel.app/",
    source: "https://github.com/AbdllhAlioglu/Javascript-Quiz",
    imageAlt:
      "JavaScript Quiz application with interactive questions testing coding knowledge and providing immediate feedback",
  },

  {
    name: "React Bank",
    description: "A simple bank app built with React and Redux.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//react-bank-app-min.webp",
    url: "https://bank-app-mu-swart.vercel.app/",
    source: "https://github.com/AbdllhAlioglu/bank-app",
    imageAlt:
      "React Bank finance application dashboard showing account balances and transaction history using modern UI components",
  },
  {
    name: "Pizza-Menu",
    description: "An interactive menu displaying various pizzas with details.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//Pizza-min.webp",
    url: "https://abdllhalioglu.github.io/pizza-menu/",
    source: "https://github.com/AbdllhAlioglu/pizza-menu",
    imageAlt:
      "Pizza Menu interactive web application showing various pizza options with pricing and ingredient details built with React",
  },
  {
    name: "Date Counter",
    description:
      "A tool to calculate and display the difference between dates.",
    photoName:
      "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//date-counter-min.webp",
    url: "https://abdllhalioglu.github.io/date-counter/",
    source: "https://github.com/AbdllhAlioglu/date-counter",
    imageAlt:
      "Date Counter application interface showing calendar date calculation tool developed with React by Abdullah Alioğlu",
  },
];

export const skillsData = [
  {
    name: "React",
    description:
      "Proficient in building modern, responsive, and user-friendly web applications with React.",
    icon: faReact,
  },
  {
    name: "HTML & CSS",
    description:
      "Skilled in building responsive layouts and designing user interfaces using HTML5 and CSS3.",
    icon: faHtml5,
  },
  {
    name: "JavaScript",
    description:
      "Experienced in writing clean, modular, and efficient code using JavaScript for front-end and back-end development.",
    icon: faJs,
  },
  {
    name: "Next.js",
    description:
      "Experienced in building server-side rendered and statically generated React applications with Next.js.",
    icon: faNodeJs,
  },
  {
    name: "Java",
    description:
      "Proficient in Java programming for building robust and scalable applications.",
    icon: faJava,
  },
  {
    name: "SQL",
    description:
      "Experienced in querying and managing databases efficiently using SQL for data-driven applications.",
    icon: faDatabase,
  },
  {
    name: "Git",
    description:
      "Proficient in using Git for version control and collaborative development.",
    icon: faGit,
  },
  {
    name: "GitHub",
    description:
      "Proficient in using GitHub for version control and collaborative development.",
    icon: faGithub,
  },
  {
    name: "Tailwind CSS",
    description:
      "Proficient in using Tailwind CSS for building responsive and modern web applications.",
    icon: faCss3,
  },
];

export const certificationsData = [
  {
    title: "Introduction to Programming with Java",
    institution: "BTK Akademi",
    date: "September 2022",
    description:
      "Gained foundational knowledge in Java programming and object-oriented concepts.",
    pdf: "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//Java.pdf",
  },

  {
    title: "Git Github Workshop",
    institution: "techcareer",
    date: "August 2024",
    description:
      "Introduced version control with Git and collaboration through GitHub, covering key concepts like branching and merging.",
    pdf: "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//Git.pdf",
  },
  {
    title: "Version Controls: Git ve GitHub",
    institution: "BTK Akademi",
    date: "July 2024",
    description:
      "Learned the fundamentals of version control using Git and collaborative workflows with GitHub.",
    pdf: "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//Gitbtk.pdf",
  },

  {
    title: "Complete Java Developer Course",
    institution: "Udemy",
    date: "March 2022",
    description:
      "Covered Java programming fundamentals, object-oriented principles, and application development best practices.",
    pdf: "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//JavaUdemy.pdf",
  },

  {
    title: "Softito Web Development Training",
    institution: "Softito Software & Information Technology Academy",
    date: "January - March 2025",
    description:
      "Comprehensive web development training program covering modern frontend and backend technologies and best practices.",
    pdf: "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//SoftITO-Sertifika.pdf",
  },
  {
    title:
      "The Ultimate React Course || React, Next.js, Tailwind CSS, Redux , Supabase ",
    institution: "Udemy",
    date: "April 2025",
    description:
      "Completed the comprehensive React course covering modern frontend technologies and best practices.",
    pdf: "https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//React-Course.pdf",
  },
];
